/**
 * API Configuration
 *
 * Centralized API base URL for the application.
 * Uses VITE_API_BASE_URL environment variable in production.
 */

export const API_BASE_URL = import.meta.env.VITE_API_BASE_URL || 'http://localhost:8090';

/**
 * Get the full API URL for a given path
 */
export function getApiUrl(path: string): string {
  const cleanPath = path.startsWith('/') ? path : `/${path}`;
  return `${API_BASE_URL}${cleanPath}`;
}
